import { HTTP } from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const convertpickListToInvoiceStore = {
    namespaced: true,
    actions: {
        savePickingListToInvoice({ commit }, param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/invoice/ConvertPLToInvoice', JSON.stringify({ PickingList: param.PickingList})).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
    }
};
export default convertpickListToInvoiceStore;